import styled from 'styled-components';
import { NoneButton } from '../AttachmentTag/AttachmentTag';
import { Button } from '../Button';
import { Input } from '../Input';
import { Select } from '../Select';

export const CreateSceneModalWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.background3};
  z-index: 99;
  overflow: hidden;
`;

export const ModalHeaderText = styled.h2`
  color: ${({ theme }) => theme.colors.font1};
`;

export const StyledCreateSceneModal = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.background2};
  box-shadow: 0 4px 4px #a5a5a5;
  border: 1px solid #e8e8e8;
  padding: 57px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CreateSceneModalContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 89px;
  align-items: start;
`;

export const CreateSceneModalHeader = styled.div`
  text-align: left;
  margin: 0 0 5px 0;
  color: ${({ theme }) => theme.colors.font1};
`;

export const CreateSceneModalParagraph = styled.p`
  color: ${({ theme }) => theme.colors.font1};
`;

export const CreateSceneModalStep = styled.span`
  color: ${({ theme }) => theme.colors.font1};
`;

export const CreateSceneModalFooter = styled.div`
  display: flex;
  width: 100%;
  margin-top: 130px;
  justify-content: space-between;
`;

export const CreateSceneNameField = styled.div`
  display: flex;
`;

export const CreateSceneNameTextField = styled(Input)`
  width: 312px;

  input {
    width: 100%;
    background-color: ${({ theme }) => theme.colors.background3};
    color: ${({ theme }) => theme.colors.font1};
  }
`;

export const CreateSceneNameTextFieldSelect = styled(Select)`
  width: 312px;

  input {
    width: 100%;
  }
`;

export const CreateSceneConfirmButton = styled(Button)`
  margin-left: 17px;
`;

export const CreateSceneCancelButton = styled(NoneButton)`
  user-select: none;
  font-weight: 600;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.font1};
`;

export const CreateSceneSecondaryText = styled.p`
  margin-top: 25px;
  font-size: 12px;
  color: #a5a5a5;
`;

export const CreateSceneStepsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CreateScenePrevStepsIcon = styled(NoneButton)`
  transform: rotate(90deg);
`;

export const CreateSceneFilterTagsWrapper = styled.div`
  .filter-tag {
    margin: 8px 8px 0 0;
  }
`;
